import { render } from "./RelatedResourceComponent.vue?vue&type=template&id=38f1d812&scoped=true&ts=true"
import script from "./RelatedResourceComponent.vue?vue&type=script&lang=ts"
export * from "./RelatedResourceComponent.vue?vue&type=script&lang=ts"

import "./RelatedResourceComponent.vue?vue&type=style&index=0&id=38f1d812&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f1d812"]])

export default __exports__